import { createIcon } from "@chakra-ui/react";

export const Pulse = createIcon({
  displayName: "Pulse",
  viewBox: "0 0 24 24",
  d: "M4.8 4.375c0-.657.536-1.188 1.2-1.188h6c.664 0 1.2.531 1.2 1.188v13.063h3.6V11.5c0-.657.536-1.188 1.2-1.188h4.8c.664 0 1.2.531 1.2 1.188 0 .657-.536 1.188-1.2 1.188h-3.6v5.937c0 .657-.536 1.188-1.2 1.188h-6c-.664 0-1.2-.531-1.2-1.188V5.562H7.2V11.5c0 .657-.536 1.188-1.2 1.188H1.2c-.664 0-1.2-.531-1.2-1.188 0-.657.536-1.188 1.2-1.188h3.6V4.375z",
  defaultProps: {
    "aria-label": "A line moving up and down to mimic a heartbeat"
  }
});

export default Pulse;
